import Modal from "../../../components/Modal/Modal";
import React from "react";
import { useApp } from "../../../contexts";
import { useWindowSize } from "../../../hook/useWindowSize";
import { useEffect, useState, useCallback  } from "react";
import { ActionLinkComponent } from "../../../components/AffiliateComponent/ActionLinkComponent";
import { AFFILIATE_LINKS } from "../../../constants";

export const ModalDetail = (props) => {
  const {
    T,
    language,
    convertToLocalCurrency,
    getCurrency,
    user
  } = useApp();
  
  const onClose = () => {
    props.onClose();
  };
  const size = useWindowSize();
  const isMobile = size.width < 1024 ? true : false;
  const { linkPreviewServe } = props;

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="750px"
        onClose={onClose}
        className={"!xls:rouded-[64px]"}
      >
        <div className="py-[10px] xls:py-0">
          <div className="flex justify-center mb-[15px]">
            <img
              className="max-w-[50px] md:max-w-none"
              src="/assets/images/affiliate-link-icon.png"
              alt=""
            />
          </div>
          <div className="text-black text-center font-medium text-[18px] lg:text-[20px] tracking-[-0.96px]">
            {props?.title}
          </div>
          <div className=" text-black mx-auto text-[16px] font-medium">
            <div className="mb-[30px] mt-[24px]">
              <div className="text-black font-[700] mb-[10px] text-[15px] lg:text-[15px] xls:text-[16px]">
                {T("Your Affiliate Link")}
              </div>
              <div className="text-aia-red font-[400] mb-[10px] text-[14px] lg:text-[14px] xls:text-[16px] break-all">
                {linkPreviewServe}
              </div>
            </div>
            <div className="mb-[30px] flex justify-start gap-3">
              <ActionLinkComponent value={linkPreviewServe} />
            </div>
            <div className="mb-[30px] font-[400] text-[14px] lg:text-[16px]">
              {T(
                "You'll earn a commission every time your audience makes a purchase with this link. We're confident you can make it happen!"
              )}
            </div>
            <a
              href="https://helpdesk.everflow.io/en/articles/6108937-guide-to-the-offer-report"
              target="_blank"
              rel="noreferrer"
              className="flex justify-start items-center gap-2 font-[400]"
            >
              <span className="text-aia-red font-[400] text-[12px]">
                {T("Know more about link’s performance reports")}
              </span>
              <svg
                className="w-[4.9px] ml-[5px]"
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="11"
                viewBox="0 0 6 11"
                fill="none"
              >
                <path
                  d="M1 1L2.69647 2.52682C4.23903 3.91512 5.01031 4.60928 5.01031 5.5C5.01031 6.39072 4.23903 7.08488 2.69647 8.47318L1 10"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>
          <div className="flex gap-3 md:gap-[20px] justify-center flex-col md:flex-row items-center mt-[40px]">
            <a
              href={AFFILIATE_LINKS.OFFERS}
              target="_blank"
              className="rounded-[14px] border border-solid px-[16px] py-[9px] bg-[#fff] text-[#000] text-center text-[14px] md:text-[16px] w-full"
              rel="noreferrer"
            >
              {T("See my link report")}
            </a>
            <button
              onClick={() => onClose()}
              className="rounded-[14px] border border-solid px-[16px] py-[9px] bg-[#000] text-[#fff] text-center text-[14px] md:text-[16px] w-full"
            >
              {T("Generate more link")}
            </button>
          </div>
        </div>
      </Modal.Container2>
    </Modal>
  );
};
